<template>
  <div class="component-loader">
    <h1>Yükleniyor...</h1>
  </div>
</template>

<script>
export default {
  name: 'ComponentDataLoader'
}
</script>

<style scoped>
h1 {
  text-align: center;
}
</style>
